import { nanoid } from 'nanoid'
import { useState } from 'react'
import { Input, InputProps, Label } from 'reactstrap'

type Props = {
    label: string
    inputProps: InputProps
    className?: string
}

export const LabeledInput = (props: Props): JSX.Element | null => {

    const [domId] = useState(nanoid(10))

    return (
        <div className={props.className}>
            <Label for={domId}>{props.label}</Label>
            <Input {...props.inputProps} id={domId} />
        </div>
    )
}
